import { DownloadAssetButton } from "hec/components/cta";

import type { RegisteredComponent } from "@builder.io/sdk-react";

interface BuilderDownloadAssetButtonProps {
  asset: string;
  fileName: string;
  ctaText: string;
  attributes?: {
    className?: string;
    [key: string]: any;
  };
  "data-testid"?: string;
}

export const BuilderDownloadAssetButton = ({
  asset,
  fileName,
  ctaText,
  attributes,
  "data-testid": dataTestId,
}: BuilderDownloadAssetButtonProps) => {
  const { className, ...restAttributes } = attributes || {};

  return (
    <DownloadAssetButton
      asset={asset}
      fileName={fileName}
      ctaText={ctaText}
      className={className}
      {...restAttributes}
      data-testid={dataTestId || "downloadAssetButton-DownloadAssetButton"}
    />
  );
};

export const DownloadAssetButtonDefinition = {
  component: BuilderDownloadAssetButton,
  name: "DownloadAssetButton",
  image: "https://unpkg.com/@mdi/svg@7.4.47/svg/download-box.svg",
  noWrap: true,
  inputs: [
    { name: "asset", type: "file", required: true },
    {
      name: "fileName",
      type: "string",
      required: true,
      helperText: "The name of the downloaded file.",
    },
    { name: "ctaText", type: "string", required: true },
  ],
} satisfies RegisteredComponent;
